import { SkyClubTracker } from '../models/skyclub.interfaces';
import {
  MultiCardCardMock,
  MultiCardsUnlimitedCard,
  MultiCardsUnlimitedMembership,
  SingleCard,
  SingleCardNotice,
  SingleCardUnlimitedCard,
  SingleCardUnlimitedMembership,
  SingleCardZero
} from './summary.mocks';

export const SkyclubTrackerSingleCardMocks: SkyClubTracker = {
  header: 'Delta Sky Club® Tracker',
  cards: SingleCard,
  disabled: false,
  loaded: true,
  error: undefined
};

export const SkyclubTrackerSingleCardNoticeMocks: SkyClubTracker = {
  header: 'Delta Sky Club® Tracker',
  cards: SingleCardNotice,
  disabled: false,
  loaded: true,
  error: undefined
};

export const SkyclubTrackerSingleCardZeroMocks: SkyClubTracker = {
  header: 'Delta Sky Club® Tracker',
  cards: SingleCardZero,
  disabled: false,
  loaded: true,
  error: undefined
};

export const SkyclubTrackerUnlimitedCardMocks: SkyClubTracker = {
  header: 'Delta Sky Club® Tracker',
  cards: SingleCardUnlimitedCard,
  disabled: false,
  loaded: true,
  error: undefined
};

export const SkyclubTrackerUnlimitedMembershipCardMocks: SkyClubTracker = {
  header: 'Delta Sky Club® Tracker',
  cards: SingleCardUnlimitedMembership,
  disabled: false,
  loaded: true,
  error: undefined
};

export const SkyclubTrackerMultipleCardMocks: SkyClubTracker = {
  header: 'Delta Sky Club® Tracker',
  cards: MultiCardCardMock,
  disabled: false,
  loaded: true,
  error: undefined
};

export const SkyclubTrackerMultipleCardUnlimitedMocks: SkyClubTracker = {
  header: 'Delta Sky Club® Tracker',
  cards: MultiCardsUnlimitedCard,
  disabled: false,
  loaded: true,
  error: undefined
};

export const SkyclubTrackerMultipleCardUnlimitedMembershipMocks: SkyClubTracker =
  {
    header: 'Delta Sky Club® Tracker',
    cards: MultiCardsUnlimitedMembership,
    disabled: false,
    loaded: true,
    error: undefined
  };
